import { currentPageActions } from '../../services';

export const currentPageReducer = ( state = {currentPage:"homePage"}, action ) => {
  switch ( action.type ) {
    case currentPageActions.SETPAGE:
      return {...state, ["currentPage"]:action.page};
    default:
      return state;
  }
};